import Lottie from 'lottie-react';

import alfieWithHeartBubble from '../jsons/alfie_with_heart_bubble.json';

const AlfieWithHeartBubble = props => {
  return <Lottie animationData={alfieWithHeartBubble} {...props} />;
};

export default AlfieWithHeartBubble;
